import axios from 'axios';

import type {
  IUserSuggestedUpdateGetPendingSuggestionsParams,
  IUserSuggestedUpdateGetPendingSuggestionsQuery,
  IUserSuggestedUpdateGetPendingSuggestionsRequest,
  IUserSuggestedUpdateGetPendingSuggestionsResponse,
} from '@/app-package';

const getPendingSuggestions = async (
  params: IUserSuggestedUpdateGetPendingSuggestionsParams,
  query: IUserSuggestedUpdateGetPendingSuggestionsQuery,
) => {
  const config: IUserSuggestedUpdateGetPendingSuggestionsRequest = {
    url: `suggested_user_update/pending/${params.userId}`,
    method: 'get',
    params: query,
  };

  const { data } =
    await axios.request<IUserSuggestedUpdateGetPendingSuggestionsResponse>(
      config,
    );

  return data;
};

export default getPendingSuggestions;
